const filterElIds = [
  'teacherId',
  'toolId',
  'schoolId',
  'year'
];

filterElIds.forEach(id => {
  $('#' + id).selectize();
});
